// PERMANENT: shared by legacy `◐…◑` streaming and typed Answer UI parts, so it stays when
// legacy marker parsing is removed. Slot N (`lumina-N`) belongs to the Nth `[^lumina^]`
// placeholder in the answer text.
export const INLINE_LUMINA_COMPONENT_KEY = 'lumina';

export const INLINE_LUMINA_PLACEHOLDER: string = `\n\n[^${INLINE_LUMINA_COMPONENT_KEY}^]\n\n`;
